import { useState } from "react"
import { isAndroidWebView } from "../../utils/webViewDetect"

const WhatsAppBanner = () => {
  const [dismissed, setDismissed] = useState(false)

  if (!isAndroidWebView() || dismissed) return null

  const openInBrowser = () => {
    const url = window.location.href
    // Try Android intent URL to open in Chrome
    window.location.href = `intent://${url.replace(/^https?:\/\//, "")}#Intent;scheme=https;package=com.android.chrome;end`
    // Fallback: open in any browser after short delay
    setTimeout(() => window.open(url, "_blank"), 1500)
  }

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 99999,
      background: "linear-gradient(90deg, #25D366 0%, #128C7E 100%)",
      padding: "10px 16px",
      display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12,
    }}>
      <p style={{ margin: 0, fontSize: 13, color: "#fff", lineHeight: 1.4, flex: 1 }}>
        Open in browser to download photos to your gallery.
      </p>
      <div style={{ display: "flex", gap: 8, alignItems: "center", flexShrink: 0 }}>
        <button
          onClick={openInBrowser}
          style={{
            padding: "6px 14px", background: "#fff", color: "#128C7E",
            border: "none", borderRadius: 20, fontSize: 12, fontWeight: 700, cursor: "pointer",
          }}
        >
          Open
        </button>
        <button
          onClick={() => setDismissed(true)}
          style={{
            background: "none", border: "none", color: "#fff",
            fontSize: 20, cursor: "pointer", padding: "0 4px", lineHeight: 1,
          }}
        >
          ×
        </button>
      </div>
    </div>
  )
}

export default WhatsAppBanner
